export type AttributeType = 'ACTUAL' | 'MAX_SET' | 'MIN_SET' | 'TARGET';

export type Mutability = 'READ_ONLY' | 'READ_WRITE' | 'WRITE_ONLY';

export interface VariableAttribute {
  type: AttributeType;
  value?: string;
  mutability: Mutability;
  persistent: boolean;
  constant: boolean;
}

export enum DataType {
  BOOLEAN = 'BOOLEAN',
  DATE_TIME = 'DATE_TIME',
  DECIMAL = 'DECIMAL',
  INTEGER = 'INTEGER',
  MEMBER_LIST = 'MEMBER_LIST',
  OPTION_LIST = 'OPTION_LIST',
  SEQUENCE_LIST = 'SEQUENCE_LIST',
  STRING = 'STRING'
}

export interface Variable {
  name: string;
  instance?: string;
  unit?: string;
  dataType: DataType;
  minLimit?: number;
  maxLimit?: number;
  enumValues?: string;
  supportsMonitoring: boolean;
  variableAttributes: VariableAttribute[];
}

export interface Component {
  name: string;
  instance?: string;
  variables: Variable[];
}

export type ComponentGroupType = 'CHARGING_STATION' | 'EVSE' | 'CONNECTOR';

export interface ComponentGroup {
  chargingStationId: string;
  type: ComponentGroupType;
  evseId?: number;
  connectorId?: number;
  componentGroups: ComponentGroup[];
  components: Component[];
}
